import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "src/shared/api/base-query";
import { pagedQueryFn } from "src/shared/api/paged-query-fn";

import { IPhenophaseDto } from "../shared";
import { Phenophase } from "../shared/models/phenophases";

export const phenophasesApi = createApi({
  reducerPath: "phenophasesApi",
  baseQuery,
  tagTypes: ["Phenophases"],
  endpoints: (builder) => ({
    fetchPhenophases: builder.query<IPhenophaseDto[], void>({
      queryFn: pagedQueryFn<IPhenophaseDto, IPhenophaseDto[]>(
        { url: "PhenoPhasesV2" },
        (dtos) =>
          dtos
            .map((dto) => {
              const model = new Phenophase(dto.id);
              model.updateFromDto(dto);
              return model;
            })
            .sort((a, b) => a.name.localeCompare(b.name))
      ),
    }),
  }),
});

export const { useFetchPhenophasesQuery } = phenophasesApi;
